<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab>Diario</v-tab>
      <v-tab>Rango de Fechas</v-tab>
      <v-tab v-if="reporte">Reporte</v-tab>
    </v-tabs>
    <SeleccionarFechas
      v-if="tab != 2"
      :esRango="tab == 1"
      @reporteGenerado="obtenerReporte"
    />
    <div>
      <Cuerpo v-if="tab == 2" :reporte="reporte" />
    </div>
  </div>
</template>

<script>
import SeleccionarFechas from "../../components/Informes/SeleccionarFechas";
import Cuerpo from "../../components/Informes/Cuerpo";
export default {
  name: "Informes_Generar",
  data() {
    return {
      tab: 0,
      loadingInforme: false,
      reporte: null,
    };
  },
  components: {
    SeleccionarFechas,
    Cuerpo,
  },
  computed: {
  },
  methods: {
    obtenerReporte(reporte) {
      this.reporte = reporte;
      this.tab = 2;
    },
  },
};
</script>
